import HeroHeading from '../Headings/HeroHeading'
import HeroDescription from '../Headings/HeroDescription'

export default function HeroBanner() {
    return (
        <div className="md:container mx-auto px-2">
            <div className="flex flex-col md:flex-row items-center space-y-5 md:space-y-0 md:space-x-8">
                <div className="md:w-2/4 text-center md:text-left md:space-y-6 space-y-2 px-1">
                    <div className="space-y-4">
                        <HeroHeading>
                            Open Letter Marketing
                            <p className="olm-gradient-text">
                                Reviews & Testimonials
                            </p>
                        </HeroHeading>{' '}
                        <HeroDescription>
                            <b>
                                Transforming Real Estate Marketing, One Success
                                Story at a Time
                            </b>
                        </HeroDescription>{' '}
                    </div>
                    <HeroDescription>
                        <p className="md:text-left">
                            At Open Letter Marketing, our clients’ success is
                            our top priority. Hear directly from real estate
                            professionals who have experienced the
                            transformative power of our{' '}
                            <strong>real estate direct mail</strong> marketing
                            services. These stories showcase the impact of our
                            tailored solutions, innovative strategies, and
                            dedicated support.
                        </p>
                    </HeroDescription>
                </div>
                <div className="md:w-2/4 md:block">
                    <img
                        src="/assets/reviews/hero.png"
                        alt="A three-panel collage of diverse, smiling professionals. A man with glasses and earbuds looks at a phone, a woman holds a tablet, and a man with arms crossed looks directly at the camera."
                        title="Diverse professional team profiles."
                        className="w-full h-auto"
                    />
                </div>
            </div>
        </div>
    )
}
